import * as React from 'react';
import PromoCodeForm from "../../components/PromoCodes/PromoCodeForm/PromCodeForm";
var PromoCode = function () {
    return (React.createElement("div", { className: "container-fluid" },
        React.createElement("div", { className: "animated fadeIn" },
            React.createElement("h1", { className: "display-3" }, "\u041D\u043E\u0432 \u043F\u0440\u043E\u043C\u043E \u043A\u043E\u0434"),
            React.createElement("hr", null),
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: " offset-md-4 col-md-5" },
                    React.createElement(PromoCodeForm, null))))));
};
export default PromoCode;



//////////////////
// WEBPACK FOOTER
// ./src/views/PromoCodes/PromoCode.tsx
// module id = 410
// module chunks = 0